import { PciChartProps } from "reports/types";
import WeeklyGenericBarChart from "../../../../../components/Reports/GenericCharts/BarCharts/WeeklyBarChart/WeeklyGenericBarChart";
import {
  untagged,
  waiting,
  unplanned,
  planned,
} from "../../../../../constants/colors";

import PciCustomLegend from "reports/pages/customers/pci/Utils/PciCustomLegend";

const barsPlanned = [
  { key: "unknown", name: "Untagged", fill: untagged, label: true },
  { key: "waiting", name: "Waiting", fill: waiting, label: true },
  { key: "unplanned", name: "Unplanned", fill: unplanned, label: true },
  { key: "planned", name: "Planned", fill: planned, label: true },
];

const bars = [
  { key: "unknown", name: "Untagged", fill: untagged, label: true },
  { key: "waiting", name: "Waiting", fill: waiting, label: true },
  { key: "unplanned", name: "Unplanned", fill: unplanned, label: true },
];

/**
 * generate and create bar chart based on given data
 */
export default function WeeklyDowntimeTrend({
  data,
  width,
  height,
  showPlanned = false,
}: PciChartProps) {
  const title = "Weekly Downtime Trend";
  return (
    <WeeklyGenericBarChart
      data={data ? data : []}
      bars={showPlanned ? barsPlanned : bars}
      xLabel={""}
      yLabel={"Downtime (Hours)"}
      title={title}
      width={width}
      height={height}
      legend={PciCustomLegend(width, title)}
    />
  );
}
